import {HealthRating} from "../domain/HealthRating";
import {Stack, Tooltip, Typography} from "@mui/material";
import {CheckCircle, ErrorOutlined, Help, Warning} from "@mui/icons-material";
import {healthRatingHeavyColor} from "../util/HealthStatusUtils";
import {RuleReport} from "../domain/RuleReport";
import {AccountComponent} from "../domain/AccountComponent";
import {useTranslation} from "react-i18next";
import {Key, useEffect, useState} from "react";

interface AccountComponentDisplayProps {
    displayName: string;
    rating: HealthRating;
    component: AccountComponent;
    rules: Array<RuleReport> | undefined;
}

const healthToIconMap = new Map([
    [HealthRating.UNKNOWN, <Help fontSize={"large"} sx={{color: healthRatingHeavyColor(HealthRating.UNKNOWN)}} />],
    [HealthRating.HEALTHY, <CheckCircle fontSize={"large"} sx={{color: healthRatingHeavyColor(HealthRating.HEALTHY)}}/>],
    [HealthRating.WARNING, <Warning fontSize={"large"} sx={{color: healthRatingHeavyColor(HealthRating.WARNING)}}/>],
    [HealthRating.SEVERE, <ErrorOutlined fontSize={"large"} sx={{color: healthRatingHeavyColor(HealthRating.SEVERE)}}/>]
]);

export function AccountComponentDisplay({displayName, rating, component, rules} : AccountComponentDisplayProps) {
    const {t, i18n} = useTranslation();
    const [componentFailedRules, setComponentFailedRules] = useState<Array<RuleReport>>();

    useEffect(() => {
        const matchingRules = rules?.filter(r => r.accountHealthCategory === component && r.healthRating !== HealthRating.HEALTHY);
        setComponentFailedRules(matchingRules);
    }, [component, rules]);

    return (
        <Tooltip title={
            <Stack>
                {componentFailedRules?.length === 0
                    ?
                    <Typography>{t('views.lookupCustomerAccountView.accountHealthPanel.noProblemsDetectedTooltip')}</Typography>
                    :
                    componentFailedRules?.map((ruleReport) => <Typography key={ruleReport.ruleName as Key}>{t(`domain.rules.${ruleReport.ruleName}`)}</Typography> ) }
            </Stack>
        }>
            <Stack alignItems={"center"}>
                {healthToIconMap.get(rating)}
                <Typography>{displayName}</Typography>
            </Stack>
        </Tooltip>
    );

}